/**
 * Hoofprint Callouts — reveal-on-scroll.
 * Adds .hpco-is-visible to .hpco-animate-on-scroll elements when they enter view.
 *
 * Robustness notes (callouts start at opacity:0, so we MUST guarantee they reveal):
 *  - No IntersectionObserver support → reveal everything immediately.
 *  - prefers-reduced-motion → reveal everything immediately (no animation).
 *  - Safety timeout → if anything is still hidden after 3s, reveal it so a callout
 *    can never get stuck as a blank/white area.
 */
( function () {
	function revealAll() {
		document.querySelectorAll( '.hpco-animate-on-scroll' ).forEach( function ( el ) {
			el.classList.add( 'hpco-is-visible' );
		} );
	}

	var reduceMotion = window.matchMedia &&
		window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	if ( reduceMotion || ! ( 'IntersectionObserver' in window ) ) {
		revealAll();
		return;
	}

	function init() {
		var els = document.querySelectorAll( '.hpco-animate-on-scroll:not(.hpco-is-visible)' );
		if ( ! els.length ) { return; }

		var observer = new IntersectionObserver( function ( entries ) {
			entries.forEach( function ( entry ) {
				if ( entry.isIntersecting ) {
					entry.target.classList.add( 'hpco-is-visible' );
					observer.unobserve( entry.target );
				}
			} );
		}, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' } );

		els.forEach( function ( el ) { observer.observe( el ); } );

		// Safety net: never let a callout stay invisible.
		setTimeout( revealAll, 3000 );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
